import { InMemoryCache } from '@apollo/client'

import type { TypedTypePolicies } from '@twisto/api-graphql'
import { introspectionResult } from '@twisto/api-graphql'

const typePolicies: TypedTypePolicies = {
  Flow: { keyFields: [] },
  Step: { keyFields: [] },
}

export const cache = new InMemoryCache({
  possibleTypes: introspectionResult.possibleTypes,
  typePolicies,
})
